import {Component, PLATFORM_ID, Inject} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {Router} from "@angular/router";
import {AuthService} from "./core/auth/auth.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'akces';
  loading:boolean = false;

  constructor(private router: Router,@Inject(PLATFORM_ID) private platformId: Object,private translateService: TranslateService) {
          /* if(!fonctionUtils.retrieve('curentLang') || fonctionUtils.retrieve('curentLang') == 'fr'){
               translate.setDefaultLang('fr');
               fonctionUtils.store('curentLang','fr');
               fonctionUtils.store('curentLangFlag',fonctionUtils.LangFlagFR);
           } else {
             translate.setDefaultLang(fonctionUtils.retrieve('curentLang'));
           }*/

    this.translateService.addLangs(['en', 'fr']);
    this.translateService.setDefaultLang('fr');
    // Active réellement une langue : sans `use()`, ngx-translate n'applique aucune
    // traduction et tous les `| translate` restent en clés brutes (régression migration).
    if (isPlatformBrowser(this.platformId)) {
      const stored = localStorage.getItem('curentLang');
      this.translateService.use(stored === 'en' ? 'en' : 'fr');
    } else {
      this.translateService.use('fr');
    }
  }


  ngOnInit() {
  }

}
